import {
  FacebookOutlined,
  HeartFilled,
  HeartOutlined,
  InstagramOutlined,
  PhoneOutlined,
  PushpinOutlined,
} from "@ant-design/icons";
import { Tenant } from "@models";
import { Col, Space } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { TenantAvatar } from "../TenantAvatar";
import Styles from "./TenantCard.styles";

interface IProps {
  tenant: Tenant;
  index?: number;
  showFavorite?: boolean;
  onFavoriteToggle?: (tenant: Tenant) => void;
  onReviewsClick?: (tenant: Tenant) => void;
  onResumeClick?: (tenant: Tenant) => void;
}

export const TenantCard: React.FC<IProps> = ({
  tenant,
  index,
  showFavorite,
  onFavoriteToggle,
  onReviewsClick,
  onResumeClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = [tenant.address, tenant.townName].filter(Boolean).join(", ");
  const profilePath = `/requests/${tenant.tenancyName}/${tenant.id}`;
  const goToTenant = () => navigate(profilePath);

  return (
    <Styles.TenantCol xs={24} md={12} $index={index}>
      <Styles.TenantCard onClick={goToTenant}>
        {showFavorite && onFavoriteToggle && (
          <Styles.FavoriteButton
            $active={tenant.isFavorite}
            onClick={(e) => {
              e.stopPropagation();
              onFavoriteToggle(tenant);
            }}
          >
            {tenant.isFavorite ? <HeartFilled /> : <HeartOutlined />}
          </Styles.FavoriteButton>
        )}

        <div>
          <Styles.CardHeaderRow gutter={12} align="middle">
            <Col flex="none">
              <TenantAvatar logo={tenant.logo} name={tenant.name} size={68} />
            </Col>
            <Styles.InfoCol flex="auto">
              <Space orientation="vertical" size={4}>
                <Styles.TenantName level={4}>
                  {/* Pravi <a>: bez njega Google ne može da pronađe profil salona,
                      a kartica sama ide preko onClick. stopPropagation da klik
                      na naziv ne navigira dvaput. */}
                  <Link to={profilePath} onClick={(e) => e.stopPropagation()}>
                    {tenant.name}
                  </Link>
                </Styles.TenantName>
                {location && (
                  <Styles.LocationText>
                    <Styles.PinIcon>
                      <PushpinOutlined />
                    </Styles.PinIcon>{" "}
                    {location}
                  </Styles.LocationText>
                )}
                {(tenant.phone || tenant.mobile) && (
                  <Space size={10} wrap>
                    {tenant.phone && (
                      <Styles.PhoneLink
                        href={`tel:${tenant.phone}`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <PhoneOutlined /> {tenant.phone}
                      </Styles.PhoneLink>
                    )}
                    {tenant.mobile && (
                      <Styles.PhoneLink
                        href={`tel:${tenant.mobile}`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <PhoneOutlined /> {tenant.mobile}
                      </Styles.PhoneLink>
                    )}
                  </Space>
                )}
              </Space>
            </Styles.InfoCol>
          </Styles.CardHeaderRow>
          {tenant.descriptionImage && onResumeClick && (
            <Styles.ResumeLink
              onClick={(e) => {
                e.stopPropagation();
                onResumeClick(tenant);
              }}
            >
              {t("MoreAboutUs")}
            </Styles.ResumeLink>
          )}
        </div>

        <div>
          <Styles.CardDivider />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space size={14}>
              {tenant.instagram && (
                <Styles.SocialLink
                  href={tenant.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <InstagramOutlined />
                </Styles.SocialLink>
              )}
              {tenant.facebook && (
                <Styles.SocialLink
                  href={tenant.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FacebookOutlined />
                </Styles.SocialLink>
              )}
            </Space>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Styles.TenantRate disabled allowHalf value={tenant.rate} />
              {onReviewsClick ? (
                <Styles.ReviewsLink
                  onClick={(e) => {
                    e.stopPropagation();
                    onReviewsClick(tenant);
                  }}
                >
                  ({tenant.rateCount}) · {t("SeeReviews")}
                </Styles.ReviewsLink>
              ) : (
                <span style={{ color: "#94a3b8", fontSize: 12 }}>
                  ({tenant.rateCount})
                </span>
              )}
            </div>
          </div>

          <Styles.BookButton
            type="primary"
            block
            onClick={(e) => {
              e.stopPropagation();
              goToTenant();
            }}
          >
            {t("BookAppointment")}
          </Styles.BookButton>
        </div>
      </Styles.TenantCard>
    </Styles.TenantCol>
  );
};
